import { StaticImage } from "gatsby-plugin-image"

import { Container, Heading } from "@trueskin-web/components"

import ProductList from "./product-list"

const Products = ({
  heading = "Die Basis jedes Sets ist Deine personalisierte Formel. Du entscheidest, welche unterstützenden Pflegeprodukte hinzugefügt werden.",
  image,
  products,
  className = "",
}) => {
  return (
    <div
      sx={{
        pb: 5,
        mb: 6,
        border: "1px",
        borderColor: "#E1E1E1",
        borderRadius: "8px",
        overflow: "hidden",
        "& h3": {
          my: 4,
        },
      }}
      className={className}
      data-component-name="web-portal-plan-selection-products"
    >
      {image || (
        <StaticImage
          src="../images/product-set-complete.webp"
          alt=""
          sx={{
            display: "block",
            background: "#F5F5F5",
          }}
          data-component-name="web-portal-plan-selection-products-image"
        />
      )}

      <Container>
        <Heading as="h3" size="xsm" sx={{ lineHeight: "body" }}>
          {heading}
        </Heading>
        <ProductList products={products} />
      </Container>
    </div>
  )
}

export default Products
